<template>
  <div class="popup-main">
    <el-dialog
      title="选择销售订单"
      width="1240px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          class="parent-table"
          size="mini"
          show-footer
          border="none"
          :showOverflow="false"
          :row-config="{ isCurrent: false, isHover: false }"
          :loading="loading"
          :columns="tableColumn"
          :data="tableData"
          :height="this.$util.getViewHeight() - 320"
        >
          <template #header_content>
            <el-form class="flex" @submit.native.prevent="searchListData">
              <el-input
                style="width: 240px"
                size="mini"
                placeholder="请输入销售单号/客户名称/业务员"
                v-model="keyword"
                clearable
              />
              <el-button
                class="m-l-10"
                type="primary"
                size="mini"
                icon="el-icon-search"
                @click="searchListData"
              >
                搜索
              </el-button>
            </el-form>
          </template>
          <template #default_content="{ row, rowIndex }">
            <div class="parent-content">
              <div class="child-header is-move">
                <div class="flex p-y-2">
                  <div class="m-r-15 t-a-l">
                    <div class="c-gray-deep">销售单号</div>
                    <div class="c-gray">{{ row.bill_code }}</div>
                  </div>
                  <div class="m-r-15 t-a-l">
                    <div class="c-gray-deep">订单类型</div>
                    <div class="c-gray">{{ row.ding_dan_lei_xing || '无' }}</div>
                  </div>
                  <div class="m-r-15 t-a-l">
                    <div class="c-gray-deep">销售日期</div>
                    <div class="c-gray">
                      {{ row.bill_date && row.bill_date.slice(0, 10) }}
                    </div>
                  </div>
                  <div class="m-r-15 t-a-l">
                    <div class="c-gray-deep">交货日期</div>
                    <div class="c-gray">
                      {{ row.jiao_huo_ri_qi ? row.jiao_huo_ri_qi.slice(0, 10) : '无' }}
                    </div>
                  </div>
                  <div class="m-r-15 t-a-l">
                    <div class="c-gray-deep">客户名称</div>
                    <div class="c-gray">{{ row.company_name || '无' }}</div>
                  </div>
                  <div class="m-r-15 t-a-l">
                    <div class="c-gray-deep">业务员</div>
                    <div class="c-gray">{{ row.saler_name || '无' }}</div>
                  </div>
                  <div class="m-r-15 t-a-l">
                    <div class="c-gray-deep">订单状态</div>
                    <div v-if="row.status_name === '暂存'" class="c-gray-light">暂存</div>
                    <div v-if="row.status_name === '待审核'" class="c-warning">待审核</div>
                    <div v-if="row.status_name === '已审核'" class="c-green">已审核</div>
                  </div>
                  <div class="m-r-15 t-a-l">
                    <div class="c-gray-deep">订单金额</div>
                    <div class="c-orange">{{ row.sales_amount_total }}元</div>
                  </div>
                  <div class="m-r-15 t-a-l flex-1">
                    <div class="c-gray-deep">备注</div>
                    <div class="c-gray">{{ row.bill_remark || '无' }}</div>
                  </div>
                </div>
              </div>
              <vxe-grid
                :ref="`refSubTable_${rowIndex}`"
                class="child-table"
                size="mini"
                show-footer
                :row-config="{ isCurrent: false, isHover: false }"
                :columns="subTableColumn"
                :data="row.tableSaleData"
              >
                <!-- slot_default -->
                <template #default_list_chan_pin_tu="{ row }">
                  <e-upload-image
                    v-if="row.list_chan_pin_tu"
                    :list.sync="row.list_chan_pin_tu"
                    disabled
                  />
                </template>
              </vxe-grid>
            </div>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupPush">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      loading: true,
      keyword: '',

      // filter
      filterData: {
        // status: 2 // 审核通过
      },
      sortData: {
        bill_id: 'desc'
      },

      // table
      tableData: [],
      tableColumn: [
        {
          type: 'radio',
          width: '0px'
        },
        {
          title: '表格头部内容',
          slots: { header: 'header_content', default: 'default_content' }
        }
      ],
      subTableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '产品图片',
          field: 'list_chan_pin_tu',
          width: 63,
          slots: { default: 'default_list_chan_pin_tu' }
        },
        {
          title: '品名',
          field: 'name',

          width: 200
        },
        {
          title: '规格',
          field: 'spec',
          width: 200
        },
        {
          title: '单位',
          field: 'unit',
          width: 120
        },
        {
          title: '数量',
          field: 'counts',
          width: 120
        },
        {
          title: '单价(元)',
          field: 'sales_price',
          width: 120
        },
        {
          title: '金额(元)',
          field: 'sales_amount',
          width: 120
        },
        {
          title: '',
          field: ''
        }
      ],
      pageOptions: {
        ...this.$constant.page
      }
    }
  },
  computed: {},
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getListData()
  },
  methods: {
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/checkBill2/list3ShangPin',
        data: {
          is_ming_xi: true,
          bill_status1: '订单',
          keyword: this.keyword,
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          filterData: this.filterData,
          sortData: this.sortData
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = data.list
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getRadioRecord() {
      return this.$refs.refTable.getRadioRecord()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setRadioRow(params.row) // 选中radio
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowRadio = this.$refs.refTable.isCheckedByRadioRow(row)
        if (isCurrentRowRadio) {
          this.$refs.refTable.clearRadioRow() // 清空radio
        } else {
          this.$refs.refTable.setRadioRow(row) // 选中radio
        }
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupPush() {
      let row = this.getRadioRecord()
      if (row) {
        this.$emit('success', this.$util.deepCopy(row))
      } else {
        this.itemChoosePrompt()
        return
      }
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
